
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transform-data",
      function () {
        return require("private-next-pages/transform-data/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/transform-data"])
      });
    }
  